import { ArrowLeft } from 'lucide-react'
import { Link, useLocation, useNavigate } from 'react-router'

/** Direct shortcuts return to their caller; settings drill-downs return to their parent. */
export function SettingsBackLink({ to = '/settings' }: { to?: string }) {
  const location = useLocation()
  const navigate = useNavigate()
  const returnToCaller = location.state?.fromAvatar === true || location.state?.fromHome === true
  const className = '-ml-2 inline-flex min-h-11 items-center gap-2 rounded-lg px-2 text-sm font-medium text-text-muted hover:bg-surface-hover hover:text-text'
  const content = <><ArrowLeft className="h-4 w-4" aria-hidden="true" />{returnToCaller ? 'Back' : 'Settings'}</>

  return returnToCaller ? (
    <button type="button" className={className} onClick={() => void navigate(-1)}>{content}</button>
  ) : (
    <Link to={to} className={className}>{content}</Link>
  )
}
